/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Chaitanya
*/

import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import ModalHalf from '@components/modal/ModalHalf';
import Button from '@components/form/Button';
import RadioButton from '@components/form/RadioButton';
import SociollaText from '@components/sociolla/SociollaText';

const radios = [
  { label: 'Salesman & Merchandiser', value: 'salesman' },
  { label: 'Beauty Advisor', value: 'beauty_advisor' },
  { label: 'Promotor', value: 'promotor' },
  { label: 'Collector', value: 'collector' },
];

const SelectNewPlanRole = ({ show, onClose, onSubmit }) => {
  const [planType, setPlanType] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted && show) {
      setPlanType('');
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  const openForm = (val = null) => {
    if (val || planType) {
      onSubmit(val ? val : planType);
    }
  };

  return (
    <ModalHalf
      testID="sales-activity-select-role-modal"
      title="Assigned Role"
      visible={show}
      onClose={() => onClose()}
      maxWidth={isWeb ? 350 : '100%'}
      spaceFromTop={isWeb ? '10%' : false}
      headerBordered={isWeb ? true : false}>
      <View style={{ width: '100%', paddingHorizontal: 15, paddingTop: 15 }}>
        <View style={{ width: '100%' }}>
          {isWeb ? (
            <SociollaText style={{ marginBottom: 10 }}>
              Choose activity role:
            </SociollaText>
          ) : (
            false
          )}
          <View style={{ width: '100%' }}>
            <RadioButton
              testID="sales-activity-select-role-type"
              orientation="vertical"
              value={planType}
              data={radios}
              onChange={(value) =>
                isWeb ? setPlanType(value) : openForm(value)
              }
            />
          </View>
        </View>
        {isWeb ? (
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              paddingVertical: 15,
            }}>
            <Button
              testID="sales-activity-select-role-next-btn"
              rounded={true}
              buttonStyle={{ width: 150 }}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                  }}>
                  Next
                </SociollaText>
              }
              onPress={() => openForm()}
            />
          </View>
        ) : (
          false
        )}
      </View>
    </ModalHalf>
  );
};

export default React.memo(SelectNewPlanRole, (prev, next) => prev == next);
